import { TextField } from '@mui/material'
import { type FC, useState } from 'react'
import {
  convertToHalfWidthNumbers,
  convertToHalfWidthNumbersWithSign,
} from './convertToHalfWidthNumbers'

type Props = {
  value: number
  min: number
  error: boolean
  onChange: (value: number) => void
}

/**
 * 入力途中の `-` を保持するためにローカルの文字列状態を持つ数値入力コンポーネント。
 * min < 0 の場合はマイナス記号を許容する変換関数を使用する。
 */
export const NumberInput: FC<Props> = ({ value, min, error, onChange }) => {
  const allowNegative = min < 0
  const [rawValue, setRawValue] = useState<string>(String(value))

  const handleChange = (input: string) => {
    const converted = allowNegative
      ? convertToHalfWidthNumbersWithSign(input)
      : convertToHalfWidthNumbers(input)
    setRawValue(converted)
    const parsed = Number.parseInt(converted, 10)
    if (!Number.isNaN(parsed)) {
      onChange(parsed)
    } else if (converted === '') {
      // 入力欄が空になったときはフォーム値を 0 にリセットする
      // '-' 単独は入力途中なので onChange を呼ばない
      onChange(0)
    }
  }

  return (
    <TextField
      value={rawValue}
      onChange={e => handleChange(e.target.value)}
      required
      autoComplete="off"
      error={error}
      sx={{ backgroundColor: 'white' }}
    />
  )
}
